import React, { forwardRef } from "react";
// @mui
import { TextField } from "@mui/material";

// ----------------------------------------------------------------------

const XTextField = forwardRef(({ ...other }, ref) => (
    <TextField
        size="medium"

        {...other}

        sx={{
            "& .MuiInputLabel-root.MuiInputLabel-outlined:not(.MuiInputLabel-sizeSmall):not(.MuiInputLabel-shrink)": {
                transform: "translate(14px, 14px) scale(1)"
            },

            // "& .MuiInputBase-root": {
            //     // height: "48px",
            //
            //     "&.MuiInputBase-sizeSmall": {
            //         height: "40px",
            //     }
            // },

            "& .MuiInputBase-root:not(.MuiInputBase-sizeSmall) .MuiInputBase-input.MuiOutlinedInput-input": {
                paddingTop: "14px",
                paddingBottom: "14px",

                ...( other?.multiline && {
                    paddingTop: 0,
                    paddingBottom: 0
                } )
            },

            "& .MuiInputBase-root.MuiInputBase-adornedStart": {
                paddingLeft: "9px"
            },

            "& .MuiMenuItem-root": {
                minHeight: "auto"
            },

            ...other?.sx
        }}

        FormHelperTextProps={{
            ...other?.FormHelperTextProps,

            variant: "caption",
            sx: {
                "&.MuiFormHelperText-root": {
                    position: "absolute",
                    bottom: 0,
                    transform: "translateY(100%)",
                    marginTop: 0,
                    textTransform: "none"
                },

                ...other?.FormHelperTextProps?.sx
            }
        }}
    />
));

export default XTextField;
